import React, { useEffect, useRef } from 'react';
import { NotificationIcon } from 'components/assets/Icons/Icons';
import { userSelector } from 'store/selectors/app-selectors';
import { useSelector } from 'react-redux';
import { isMobileApp } from 'utils/detect-environment';
import { getFeatureFlags } from 'core/flow-control';
import { Icon, IconButton } from '@placer-ui/components';
import { Button as OldButton } from 'antd';
import styles from './notifications-button.module.scss';

const BEAMER_SCRIPT_ID = 'beamer-script';

export const NotificationsButton = () => {
    const user = useSelector(userSelector);
    const { show_notification_quick_access: showNotificationsButton, accessibility_components_ff } =
        getFeatureFlags();
    const scriptLoadedRef = useRef(false);

    useEffect(() => {
        if (isMobileApp() || !showNotificationsButton || !user || !user.email) {
            return;
        }

        const isScriptLoaded = document.getElementById(BEAMER_SCRIPT_ID);
        if (isScriptLoaded || scriptLoadedRef.current) {
            return;
        }

        scriptLoadedRef.current = true;

        window.beamer_config = {
            product_id: process.env.REACT_APP_BEAMER_PRODUCT_ID || '',
            selector: 'beamerButton',
            lazy: false,
            button: false,
            user_firstname: user.fullName || '',
            user_lastname: '',
            user_email: user.email,
            domain: user.email.split('@').pop() || '',
            user_id: user.email,
            filter_by_url: true,
        };

        const script = document.createElement('script');
        script.src = 'https://app.getbeamer.com/js/beamer-embed.js';
        script.async = true;
        script.id = BEAMER_SCRIPT_ID;
        script.onload = () => {
            if (window.Beamer) {
                window.Beamer.init();
            }
        };

        document.head.appendChild(script);

        return () => {
            // Remove the script if the component unmounts
            const loadedScript = document.getElementById(BEAMER_SCRIPT_ID);
            if (loadedScript) {
                document.head.removeChild(loadedScript);
            }
            delete window.beamer_config;
            scriptLoadedRef.current = false;
        };
    }, [showNotificationsButton, user]);

    if (!showNotificationsButton) {
        return null;
    }

    if (accessibility_components_ff) {
        return (
            <IconButton
                aria-label="notifications"
                variant="ghost"
                size="small"
                Icon={<Icon type="Bell" size={24} allowHoverState />}
                testId="beamerButton"
                // @ts-ignore - TODO: Remove this when `IconButton` will support passing an `id` prop (PLAC-68987)
                id="beamerButton"
            />
        );
    }

    return (
        <div className={styles.notificationsButton}>
            <OldButton icon={<NotificationIcon />} id="beamerButton" />
        </div>
    );
};
